const style = {
  cursor: "pointer",
  border: "solid 1px #E0E0E0",
  borderRadius: 10,
  padding: 9,
  textAlign: "center"
};

export function NoImage(props) {
  return (<>
    <div style={ style }>이미지 없음</div>
  </>);
}
